import React from 'react'
import OneColWrapper from '../technical/OneColWrapper'

import Postit from '../atoms/Postit'

const PostitBlock = ({ block }) => {
  return (
    <OneColWrapper block={block} className="postit-block">
      <Postit text={block.text} text_size={block.text_size} />
    </OneColWrapper>
  )
}

export default PostitBlock
